export function isVideoAskMessageEvent(message: MessageEvent): boolean {
  const trustedOrigins = ["https://www.videoask.com"];
  if (!trustedOrigins.includes(message.origin)) {
    return false;
  }

  const data = message.data as { type: string };
  return typeof data === "object" && "type" in data && data.type.startsWith("videoask_");
}
